import i18next from "i18next";
import translationEN from "../assets/locales/GMUSFSharedNavResourceBundle.json";

i18next.init(
    {
        lng: localStorage.getItem("lan"),
        resources: {
            en: {
                translation: translationEN
            }
        },
        fallbackLng: "en",
        debug: true
    },
    (err, t) => {
        if (err) return;
        console.log("something went wrong loading", err);
        t("key"); // -> same as i18next.t
    }
);

export default i18next;
